<article
  class="attachments_card"
  *ngIf="batchDeparture$ | async as batchDeparture; else elseBlock"
  [ngClass]="{ attachments_card__full: isFullScreen$ | async }"
>
  <ng-container *ngIf="departureForm">
    <header class="attachments_card__header">
      <span class="attachments_card__header-title"
        >{{ 'BATCH_MAILING.BATCHES_TAB.ATTACHMENT_CARD.DEPARTURE' | translate }}
        {{ batchDeparture.s10code }}
      </span>

      <section class="attachments_card__header-control">
        <a
          class="filter-button azure"
          type="button"
          (click)="toggleFullScreen()"
        >
          <span
            class="filter-button-icon fullscreen-btn"
            [inlineSVG]="
              '../assets/img/icons/fullscreen-' +
              ((isFullScreen$ | async) ? 'off' : 'on') +
              '.svg'
            "
          ></span>
          <span>{{
            ((isFullScreen$ | async) ? 'FULLSCREEN_OFF' : 'FULLSCREEN_TOOLTIP')
              | translate
          }}</span>
        </a>

        <button
          class="filter-button red"
          type="button"
          (click)="confirmDeleteDeparture()"
        >
          <fa-icon class="filter-button-icon red" [icon]="faTrashAlt">
          </fa-icon>
          <span class="red">{{
            'BATCH_MAILING.BATCHES_TAB.ACTIONS.DELETE_DEPARTURE' | translate
          }}</span>
        </button>
      </section>
    </header>

    <section class="attachments_card__info">
      <section class="attachments_card__info-item">
        <span class="attachments_card__info-item-sub-title">
          {{
            'BATCH_MAILING.BATCHES_TAB.ATTACHMENT_CARD.SHIPMENTS_COST_DEPENDS_ON'
              | translate
          }}
        </span>

        <div class="attachments_card__info-item-title">
          <span>
            {{
              'BATCH_MAILING.BATCHES_TAB.ATTACHMENT_CARD.SHIPPING_COST'
                | translate
            }}:</span
          >
          <span> {{ batchDeparture.cost }} </span>
          <span>{{
            'BATCH_MAILING.BATCHES_TAB.ATTACHMENT_CARD.RUB' | translate
          }}</span>
        </div>
      </section>

      <section class="attachments_card__info-item">
        <span class="attachments_card__info-item-sub-title">
          {{
            'BATCH_MAILING.BATCHES_TAB.ATTACHMENT_CARD.AMOUNT_CASH_ON_DELIVERY_CALCULATED'
              | translate
          }}
        </span>

        <div class="attachments_card__info-item-title">
          <span>
            {{
              'BATCH_MAILING.BATCHES_TAB.ATTACHMENT_CARD.CASH_ON_DELIVERY'
                | translate
            }}:</span
          >
          <span> {{ departureForm.get('cash_on_delivery')?.value || 0 }} </span>
          <span>{{
            'BATCH_MAILING.BATCHES_TAB.ATTACHMENT_CARD.RUB' | translate
          }}</span>
        </div>
      </section>
    </section>

    <form [formGroup]="departureForm" #formEl>
      <section class="form-control">
        <label for="declared_value">{{
          'BATCH_MAILING.BATCHES_TAB.CREATE_MODAL.DECLARED_VALUE' | translate
        }}</label>
        <input
          type="number"
          (keydown)="deleteSymbols($event, true)"
          formControlName="declared_value"
          [asterisk]="false"
          name="declared_value"
          id="declared_value"
        />
        <app-custom-control-error
          *ngIf="departureForm?.get('declared_value')?.touched"
          [setErrors]="departureForm?.get('declared_value')?.errors"
        >
        </app-custom-control-error>
      </section>

      <section class="form-control">
        <label for="weight">{{
          'BATCH_MAILING.BATCHES_TAB.CREATE_MODAL.WEIGHT' | translate
        }}</label>
        <input
          type="number"
          formControlName="weight"
          name="weight"
          [asterisk]="true"
          (keydown)="deleteSymbols($event, false)"
          id="weight"
        />
        <app-custom-control-error
          *ngIf="departureForm?.get('weight')?.touched"
          [setErrors]="departureForm?.get('weight')?.errors"
        >
        </app-custom-control-error>
      </section>
    </form>

    <section>
      <section class="tabs tabs--thin tabs--in-box tabs-with-state-tab">
        <p class="attachments_card__count-block">
          {{ batchDeparture.partial_receipts_count }}/20
          {{
            'BATCH_MAILING.BATCHES_TAB.ATTACHMENT_CARD.attachments' | translate
          }}
        </p>
        <div class="nav" id="nav-tab" role="tablist">
          <a
            class="nav-item nav-link"
            [ngClass]="{ active: activeTab === 1 }"
            data-toggle="tab"
            routerLinkActive="active"
            role="tab"
            (click)="setActiveTab(1)"
          >
            {{
              'BATCH_MAILING.BATCHES_TAB.ATTACHMENT_CARD.DELIVERY_INFO'
                | translate
            }}
          </a>
          <a
            class="nav-item nav-link"
            [ngClass]="{ active: activeTab === 2 }"
            data-toggle="tab"
            routerLinkActive="active"
            role="tab"
            (click)="setActiveTab(2)"
          >
            {{
              'BATCH_MAILING.BATCHES_TAB.ATTACHMENT_CARD.ATTACHMENTS'
                | translate
            }}
          </a>
        </div>
        <div class="tabs__line" aria-hidden="true"></div>
      </section>

      <app-view-attachments-info
        [searchParam]="queryParams.search || ''"
        (sendDeletingAttachmentsIds)="confirmDeleteAttachments($event)"
        (batchDeparturesParamsChange)="onQueryParamsChange($event)"
        [isAttachmentLoading$]="isAttachmentLoading$"
        [activeTab]="activeTab"
      >
      </app-view-attachments-info>
    </section>

    <footer
      class="attachments_card__footer"
      [ngStyle]="{
        'justify-content': activeTab === 1 ? 'space-between' : 'flex-end',
      }"
    >
      <button
        *ngIf="activeTab === 1"
        class="button filter-button button--link-blue"
        (click)="navigateToEditDeparturePage()"
      >
        <fa-icon class="filter-button-icon" [icon]="faPenToSquare"> </fa-icon>
        <span>{{ 'EDIT' | translate }}</span>
      </button>

      <div class="attachments_card__footer-manage-btns">
        <button
          type="button"
          class="button button--outlined"
          (click)="backToViewBatch()"
        >
          {{ 'BACK' | translate }}
        </button>

        <button
          class="button button--filled"
          [disabled]="!batchDeparture.partial_receipts_count"
          (click)="saveDeparture()"
        >
          <span>{{ 'SAVE' | translate }}</span>
        </button>
      </div>
    </footer>
  </ng-container>
</article>

<ng-template #elseBlock>
  <main class="text-secondary text-center">
    <div class="spinner-border spinner-border-lg" role="status">
      <span class="sr-only">{{ 'LOADING' | translate }}</span>
    </div>
  </main>
</ng-template>
